export default __webpack_public_path__ + "static/media/franquia.cef3b982.jpg";